module.exports = __webpack_public_path__ + "static/media/grayscale.cde32e31.jpg";